import { uniq } from './uniq';

export function union<T, U>(a: readonly T[], b: readonly U[]) {
  return uniq([...b, ...a]);
}
